import * as React from 'react';
import { Image, LinkButton, UIHeading4, UIHeading5 } from '@cian/ui-kit';

import { INewbuildingMapPin } from '../../../../types/map';
import { NewbuildingCallButton } from '../../../../containers/NewbuildingCallButton';
import { Link } from '../../../Link';
import { Rating } from '../../../NewbuildingsComparePage/parts/Cell/cells/NewbuildingSummaryCell/parts/Rating';
import { TransportPointRow } from '../../../NewbuildingsComparePage/parts/Cell/cells/TransportPointExtendedCell/parts';
import { trackNavigationToCardJKFromMap, trackShowPhoneFromMap } from '../../../../containers/NewbuildingsMap/tracking';
import * as styles from './styles.css';

export interface INewbuildingPreviewProps {
  pin: INewbuildingMapPin;
}

export const NewbuildingPreview = ({ pin }: INewbuildingPreviewProps): React.JSX.Element => {
  const { newbuilding, transportPoint } = pin;
  const { builders, fullUrl, id, imageUrl, name, priceRange, reviews, sellers } = newbuilding;

  const builderId = builders[0]?.id;

  const handleNavigateToCardJK = React.useCallback(() => {
    trackNavigationToCardJKFromMap({ newbuildingId: id, builderId });
  }, [builderId, id]);

  const handleShowPhone = React.useCallback(() => {
    trackShowPhoneFromMap({ newbuildingId: id, builderId });
  }, [builderId, id]);

  return (
    <div className={styles['container']} data-testid="newbuildings-map-preview">
      <Image alt={name} borderRadius="8px" height={160} objectFit="cover" src={imageUrl} width="100%" />
      <div className={styles['info']}>
        <Link href={fullUrl} target="_blank" onClick={handleNavigateToCardJK}>
          <UIHeading5 color="text-primary-default">{name}</UIHeading5>
        </Link>
        {priceRange && <UIHeading4>{priceRange}</UIHeading4>}
        <Rating countText={reviews.countText} rating={reviews.rating} />
        {transportPoint && <TransportPointRow item={transportPoint} />}
      </div>
      <div className={styles['buttons']}>
        <NewbuildingCallButton
          builders={builders}
          newbuildingId={id}
          sellers={sellers}
          size="M"
          url={fullUrl}
          onShowPhone={handleShowPhone}
        />
        <LinkButton
          href={fullUrl}
          rel="noreferrer"
          size="M"
          target="_blank"
          theme="main_secondary"
          onClick={handleNavigateToCardJK}
        >
          Подробнее о ЖК
        </LinkButton>
      </div>
    </div>
  );
};
